import { StorefrontPlugins } from '@engyalo/storefront-types'
import { Grid } from '@chakra-ui/core'
import { CustomProduct } from './plugins/CustomProduct'
import { CustomProductFooter } from './plugins/CustomProductFooter'
import { HorizontalProduct } from './plugins/HorizontalProduct'
import { CustomCartItem } from './plugins/CustomCartItem'

export const plugins = {
  Catalogue: {
    container: Grid,
    props: {
      gridTemplateColumns: '1fr',
      gridRowGap: '0',
    },
  },
  CollectionProduct: {
    container: HorizontalProduct,
  },
  ProductDetailBody: {
    container: CustomProduct,
  },
  ProductAddToCart: {
    container: CustomProductFooter,
  },
  CartItemDetail: {
    container: CustomCartItem,
  },
} as StorefrontPlugins
